// extracted by mini-css-extract-plugin
module.exports = {"medium":"Button_medium__1tGCu","small":"Button_small__2b5wA","large":"Button_large__1x546"};